/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_SourcesInputs */

const en_us2_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const pt_br2_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes`)
};

const es_419_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes`)
};

const pt_pt2_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes`)
};

const fr_fr2_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const de_de2_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellen`)
};

const it_it2_coach_sources = /** @type {(inputs: Coach_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonti`)
};

/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Coach_SourcesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_sources = /** @type {((inputs?: Coach_SourcesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_SourcesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_sources(inputs)
	if (locale === "es-419") return es_419_coach_sources(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_sources(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_sources(inputs)
	if (locale === "de-DE") return de_de2_coach_sources(inputs)
	if (locale === "it-IT") return it_it2_coach_sources(inputs)
	return en_us2_coach_sources(inputs)
});
export { coach_sources as "coach.sources" }